<template>
  <router-view v-slot="{ Component, route }">
    <component :is="layoutTypeToComponentMapper[route.meta.layout ?? 'Admin']">
      <div>
        <!--        <transition mode="in-out" name="fade">-->
        <component :is="Component" :key="route.path" />
        <!--        </transition>-->
      </div>
    </component>
  </router-view>

  <plan-pricing />
</template>

<script>
import { authComputed, authMethods } from './state/helpers';
import PlanPricing from '@/components/plan-pricing.vue';
import usePlanPrice from '@/composable/plan-price';
import useNotifications from '@/composable/notifications';

import { layoutTypeToComponentMapper } from '@/layouts/layoutHelper';
import i18n from '@/i18n';

const { fetchIfNotificationExist } = useNotifications();
const { fetchPlans } = usePlanPrice();
const { fetchTenantInfoPlans } = usePlanPrice();

export default {
  name: 'App',
  computed: {
    layoutTypeToComponentMapper() {
      return layoutTypeToComponentMapper;
    }
  },
  components: { PlanPricing },
  data() {
    return {
      dialogVisible: true
    };
  },
  methods: {
    ...authMethods,
    ...authComputed,
    fetchData() {
      this.$store.dispatch('groups/fetchGroups');
      this.$store.dispatch('user/getAllUser');
    }
  },

  mounted() {
    // get theme from local storage if available and set it to the document element
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      document.documentElement.setAttribute('data-bs-theme', savedTheme);
      document.querySelector('html').classList.add(savedTheme);
    }
    const savedLang = localStorage.getItem('lang');
    if (savedLang) i18n.global.locale = savedLang;
  },

  created() {
    if (localStorage.getItem('access_token')) {
      fetchTenantInfoPlans();
      fetchIfNotificationExist();

      fetchPlans();

      this.getUsersData();
      this.fetchData();
    }
  }
};
</script>
<style>
/* Global styles */
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-y: hidden;
}

.gradient-text {
  background: linear-gradient(135deg, #f06548, #f79d65, #f0c14b);
  -webkit-background-clip: text;
  color: transparent;
}

/* Custom scrollbar for WebKit-based browsers (Chrome, Safari, Edge, etc.) */
::-webkit-scrollbar {
  width: 4px; /* Thin scrollbar width */
  height: 6px; /* Thin scrollbar height (for horizontal scrollbars) */
}

::-webkit-scrollbar-thumb {
  background-color: rgba(200, 200, 200, 0.6); /* Very light gray with transparency */
  border-radius: 10px; /* Rounded corners for a modern feel */
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(200, 200, 200, 0.8); /* Slightly darker on hover */
}

::-webkit-scrollbar-track {
  background-color: transparent; /* Fully transparent track */
}

::-webkit-scrollbar-corner {
  background-color: transparent; /* Transparent corner for overflow intersections */
}

/* Custom scrollbar for Firefox */
* {
  scrollbar-width: thin; /* Thin scrollbar */
  scrollbar-color: rgba(200, 200, 200, 0.6) transparent; /* Light gray thumb with transparent track */
}

/* Add smooth scrolling behavior for all browsers */
html {
  scroll-behavior: smooth;
}

.disabled-link {
  pointer-events: none;
}

/* ✅ PRINT STYLES (Hides Scrollbars & Shows All Content) */
@media print {
  html,
  body,
  #app {
    height: auto !important; /* Allow full content height */
    overflow: visible !important; /* Prevent any scrolling issues */
  }

  /* Remove all scrollbars from appearing in print mode */
  ::-webkit-scrollbar,
  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track,
  ::-webkit-scrollbar-corner {
    display: none !important;
    width: 0px !important;
    height: 0px !important;
  }

  /* Forcefully hide overflow and ensure all content is printed */
  * {
    max-height: none !important;
    overflow: visible !important;
  }

  /* Ensure content that is scrollable becomes fully visible */
  .scrollable-content,
  .content-container {
    max-height: none !important;
    overflow: visible !important;
    height: auto !important;
  }

  /* Page breaks for large content */
  .page {
    page-break-before: always;
  }
}
</style>
